import React, { FC } from 'react';
import { UseMutationResult } from 'react-query';
import { useTranslate } from '@im/react-localization';
import { Form, FormCtrl } from 'src/components/Form';

interface RemoveProductsProps {
  initialState: any[];
  mutation: UseMutationResult<any, any, number[], any>;
  onClose: () => void;
}
export const RemoveProducts: FC<RemoveProductsProps> = ({
  initialState,
  mutation,
  onClose,
}) => {
  const translate = useTranslate();

  const fieldsComponent = (formCtrl: FormCtrl<any>): JSX.Element => <></>;
  return (
    <Form<number[]>
      fields={fieldsComponent}
      getErrorMsg={(error, msg) => {
        if (error.response?.statusCode !== 400) {
          return msg;
        }
      }}
      initialState={initialState}
      mutation={mutation}
      onClose={onClose}
      submitLabel={translate('CustomerGroups.removeCustomersFromGroup')}
      sx={{
        padding: 0,
      }}
    />
  );
};
